import { FC, useState } from 'react';
import { ComputedProject } from '../../../helpers/types/computed/ComputedProject';
import { useTranslation } from "react-i18next";
import { Colors, useIsMobile } from "@brg/ui";
import styled from "styled-components";
import ResizedImageEnhanced from "../../../components/ResizedImageEnhanced";
import {LayoutConst} from "../../../../core";
import { useSelector } from "react-redux";
import { CurrentProjectSelector } from "../../../reducers/CurrentProject";
import { RatingImgGenerate } from 'shared/pages/opencallsPage/GetCompetitionItem/components/RatingImgGenerate';
import { ZharKnigaBadge } from 'shared/pages/opencallsPage/GetCompetitionItem/components/ZharKnigaBadge';
import { Competition } from '@brg/api';
import { useZharKnigaWinner } from 'shared/hooks/useZharKnigaWinner';

export const getProjectImages = (project: any, lang: any) => {
  //@ts-ignore
  const isBilingual = !!project?.isBilingual;
  const hasTitleEnBG = project?.titleImages_en?.length;
  
  if (isBilingual || hasTitleEnBG) {
    if (lang === 'en' && project?.titleImages_en?.length) {
      return project?.titleImages_en
    }
    if (lang === 'ru' && project?.titleImages?.length) {
      return project?.titleImages
    }
    return project?.titleImages?.length ? project?.titleImages : project?.titleImages_en;
  }
  return project?.titleImages || [];

}

const ProjectImage = styled(ResizedImageEnhanced)<{ isSquare?: boolean }>`
  img {
    height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
    width: 100%;
    object-fit: cover;
  }
  overflow: hidden;
`

const ProjectImageSize = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.geoWhite100};
  padding: 4px 8px;
  background: rgba(21, 21, 20, 0.4);
  border-radius: 2px;
  opacity: 0;
  transition: opacity 0.2s;
  
  span {
    font-weight: 400;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    opacity: 1;
  }
`

const ProjectImageWrapper = styled.div<{ isSquare?: boolean }>`
  position: relative;
  width: 100%;
  height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
  
 &:hover ${ProjectImageSize} {
   opacity: 1;
   transition-delay: 3s;
 }
`

export const PSImage: FC<{ project: ComputedProject; onClick?: (img: string) => void; competitionInfo?: any}> = ({ project, onClick, competitionInfo }) => {
    // return (
    //     <ProjectImage
    //         onContextMenu={(event) => {
    //             event.preventDefault();
    //         }}
    //         onClick={() => onClick?.(project.image)}
    //         img={project.image}
    //     />
    // );
  const { i18n, t } = useTranslation();
  const isMobile = useIsMobile();
  const showOriginal = useSelector(CurrentProjectSelector)?.showOriginals;
  const [onhoverPlate, setOnhoverPlate] = useState(false);
  
  
  const images = getProjectImages(project, i18n.language) || [];
  const size = (i18n?.language === 'ru' || project?.originalImageInfoEn?.width === 0) ? project?.originalImageInfo : project?.originalImageInfoEn;

  const ratingCompetition = competitionInfo?.find((item: Competition) => item.contexts?.includes("ratings"))
  // @ts-ignore
  const isRatingWinner = ratingCompetition?.nominations?.[0]?.winnerPositions?.some(item => item?.winnerId === project?.projectId) ?? false
  
  // Жар-книга competition
  const { isWinner: isZharKnigaWinner } = useZharKnigaWinner(project?.projectId);
  
  return (
      <ProjectImageWrapper onMouseEnter={() => setOnhoverPlate(true)} onMouseLeave={() => setOnhoverPlate(false)}>
        {!isMobile && (
          <ProjectImageSize>
          {t('project.original_size')}
            {' '}
          <span>{size?.width ?? 0}x{size?.height ?? 0}</span>
        </ProjectImageSize>
        )}
        {/* Шильдики конкурсов */}
        {(isRatingWinner || isZharKnigaWinner) && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            zIndex: 10
          }}>
            {isRatingWinner && (
              <RatingImgGenerate competition={ratingCompetition} isPlate={true} onhoverPlate={onhoverPlate}/>
            )}
            {isZharKnigaWinner && (
              <ZharKnigaBadge isGridBadge={false} onhoverPlate={onhoverPlate} />
            )}
          </div>
        )}
        <ProjectImage files={images} isSquare={false} showOriginal={showOriginal}/>
      </ProjectImageWrapper>
  )
};
import { FC, useState } from 'react';
import { ComputedProject } from '../../../helpers/types/computed/ComputedProject';
import { useTranslation } from "react-i18next";
import { Colors, useIsMobile } from "@brg/ui";
import styled from "styled-components";
import ResizedImageEnhanced from "../../../components/ResizedImageEnhanced";
import {LayoutConst} from "../../../../core";
import { useSelector } from "react-redux";
import { CurrentProjectSelector } from "../../../reducers/CurrentProject";
import { RatingImgGenerate } from 'shared/pages/opencallsPage/GetCompetitionItem/components/RatingImgGenerate';
import { ZharKnigaBadge } from 'shared/pages/opencallsPage/GetCompetitionItem/components/ZharKnigaBadge';
import { Competition } from '@brg/api';
import { useZharKnigaWinner } from 'shared/hooks/useZharKnigaWinner';

export const getProjectImages = (project: any, lang: any) => {
  //@ts-ignore
  const isBilingual = !!project?.isBilingual;
  const hasTitleEnBG = project?.titleImages_en?.length;
  
  if (isBilingual || hasTitleEnBG) {
    if (lang === 'en' && project?.titleImages_en?.length) {
      return project?.titleImages_en
    }
    if (lang === 'ru' && project?.titleImages?.length) {
      return project?.titleImages
    }
    return project?.titleImages?.length ? project?.titleImages : project?.titleImages_en;
  }
  return project?.titleImages || [];

}

const ProjectImage = styled(ResizedImageEnhanced)<{ isSquare?: boolean }>`
  img {
    height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
    width: 100%;
    object-fit: cover;
  }
  overflow: hidden;
`

const ProjectImageSize = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.geoWhite100};
  padding: 4px 8px;
  background: rgba(21, 21, 20, 0.4);
  border-radius: 2px;
  opacity: 0;
  transition: opacity 0.2s;
  
  span {
    font-weight: 400;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    opacity: 1;
  }
`

const ProjectImageWrapper = styled.div<{ isSquare?: boolean }>`
  position: relative;
  width: 100%;
  height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
  
 &:hover ${ProjectImageSize} {
   opacity: 1;
   transition-delay: 3s;
 }
`

export const PSImage: FC<{ project: ComputedProject; onClick?: (img: string) => void; competitionInfo?: any}> = ({ project, onClick, competitionInfo }) => {
    // return (
    //     <ProjectImage
    //         onContextMenu={(event) => {
    //             event.preventDefault();
    //         }}
    //         onClick={() => onClick?.(project.image)}
    //         img={project.image}
    //     />
    // );
  const { i18n, t } = useTranslation();
  const isMobile = useIsMobile();
  const showOriginal = useSelector(CurrentProjectSelector)?.showOriginals;
  const [onhoverPlate, setOnhoverPlate] = useState(false);
  
  
  const images = getProjectImages(project, i18n.language) || [];
  const size = (i18n?.language === 'ru' || project?.originalImageInfoEn?.width === 0) ? project?.originalImageInfo : project?.originalImageInfoEn;

  const ratingCompetition = competitionInfo?.find((item: Competition) => item.contexts?.includes("ratings"))
  // @ts-ignore
  const isRatingWinner = ratingCompetition?.nominations?.[0]?.winnerPositions?.some(item => item?.winnerId === project?.projectId) ?? false
  
  // Жар-книга competition
  const { isWinner: isZharKnigaWinner } = useZharKnigaWinner(project?.projectId);
  
  return (
      <ProjectImageWrapper onMouseEnter={() => setOnhoverPlate(true)} onMouseLeave={() => setOnhoverPlate(false)}>
        {!isMobile && (
          <ProjectImageSize>
          {t('project.original_size')}
            {' '}
          <span>{size?.width ?? 0}x{size?.height ?? 0}</span>
        </ProjectImageSize>
        )}
        {/* Шильдики конкурсов */}
        {(isRatingWinner || isZharKnigaWinner) && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            zIndex: 10
          }}>
            {isRatingWinner && (
              <RatingImgGenerate competition={ratingCompetition} isPlate={true} onhoverPlate={onhoverPlate}/>
            )}
            {isZharKnigaWinner && (
              <ZharKnigaBadge isGridBadge={false} onhoverPlate={onhoverPlate} />
            )}
          </div>
        )}
        <ProjectImage files={images} isSquare={false} showOriginal={showOriginal}/>
      </ProjectImageWrapper>
  )
};
